/* import __COLOCATED_TEMPLATE__ from './article-suggestion-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();